import { render, staticRenderFns } from "./RequestAdditionalInfo.vue?vue&type=template&id=2df7b7df"
import script from "./RequestAdditionalInfo.vue?vue&type=script&lang=js"
export * from "./RequestAdditionalInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports